/**
 * Video module
 *
 * @module Video
 */
(function Video() {

    /**
     * Provided function gets called when browser is ready for js rendering
     * @param fn
     */
    function ready(fn) {
        if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
        document.addEventListener('afterCookieConsent', fn);
    }

    /**
     * Rendering a simple video
     * @param {dom} videoContentElement
     * @class {simpleVideo}
     * @constructor
     */
    function simpleVideo(videoContentElement) {
        var video = videoContentElement.querySelectorAll('video')[0];
        var playButton = videoContentElement.querySelectorAll('[data-techdivision-simplevideo="play"]')[0];
        // play video on click
        playButton.addEventListener("click", function () {
            // hide play button
            playButton.style.display = "none";
            video.setAttribute("controls", "controls");
            video.play();
            dispatchVideoEvent("playVideo");
        }, false);
        // display button when video has ended
        video.addEventListener('ended', function () {
            playButton.style.display = "block";
            video.removeAttribute("controls");
        }, false);
    }

    /**
     * Rendering a embed video
     * @param {dom} videoContentElement
     * @class {embedVideo}
     * @constructor
     */
    function embedVideo(videoContentElement) {
        var previewImage = videoContentElement.querySelectorAll('.js__preview-image img')[0];
        var playButton = videoContentElement.querySelectorAll('[data-techdivision-embedvideo="play"]')[0];
        var videoType = videoContentElement.dataset.videotype;
        var video = videoContentElement.querySelectorAll('[data-video="embedVideo"]')[0];

        if (previewImage) {
            // play video on click
            playButton.addEventListener("click", function () {
                // hide play button
                playButton.style.display = "none";
                previewImage.style.display = "none";
                if (videoType === 'youtube') {
                    youtubeSetup(video);
                } else if (videoType === 'vimeo') {
                    video.src += '&autoplay=1';
                    // display button when video has ended
                    video.addEventListener('ended', function () {
                        playButton.style.display = "block";
                    }, false);
                    dispatchVideoEvent("playVideo");
                }
            }, false);
        }
    }


    /**
     * setup youtube, check if YT api is present if not add it and wait for load
     * @param video
     */
    function youtubeSetup(video) {
        try {
            createYoutubeIframe(video);
        } catch (e) {
            // dispatch event for listen to
            dispatchVideoEvent("youTubeSetup");
            // insert YT API if not present
            var youTubeApi = document.createElement('script');
            youTubeApi.type = 'text/javascript';
            youTubeApi.async = true;
            youTubeApi.src = 'https://www.youtube.com/iframe_api';
            video.parentNode.insertBefore(youTubeApi, video);
            youTubeApi.addEventListener('load', function() {
                checkApi(video, 1);
            });
        }
    }

    /**
     * check if api is present an build iframe if it is, if not recursive call up to 10 times
     * @param video
     * @param round
     */
    function checkApi(video, round) {
        if(round > 10) {
            console.log('YouTube API could not be loaded properly, please inform an administrator!')
        } else {
            try {
                createYoutubeIframe(video);
            } catch (e) {
                setTimeout(function() {
                    checkApi(video, ++round);
                }, 1000);
            }
        }
    }

    /**
     * This function creates an <iframe> (and YouTube player)
     * @param video
     */
    function createYoutubeIframe(video) {
        new YT.Player(video.id, {
            height: video.dataset.height,
            width: video.dataset.width,
            host: 'https://www.youtube-nocookie.com',
            videoId: video.dataset.videoid,
            playerVars: {
                autoplay: 1,
                controls: 1,
                showinfo: 1,
                rel: 0,
                iv_load_policy: 3,
                cc_load_policy: 0,
                fs: 0,
                disablekb: 1,
            },
            events: {
                'onReady': onPlayerReady,
            }
        });

        /**
         * The API will call this function when the video player is ready.
         * @param event
         */
        function onPlayerReady(event) {
            dispatchVideoEvent("youTubeReady");
            event.target.playVideo();
        }
    }


    /**
     * call playVideo Event
     *
     * e.g. you can add a listener like this:
     *    document.addEventListener("playVideo", function () {
     *        do something...
     *    });
     */
    function dispatchVideoEvent(eventName = "playVideo") {
        var event = document.createEvent("Event");
        event.initEvent(eventName, false, true);
        document.dispatchEvent(event);
    }

    ready(function () {
        // iterate all video content elements and create instances
        var simpleVideoContentElements = document.querySelectorAll('[data-techdivision-simplevideo="wrapper"]');
        var embedVideoContentElements = document.querySelectorAll('[data-techdivision-embedvideo="wrapper"]');
        for (i = 0; i < simpleVideoContentElements.length; ++i) {
            var simdpleVideoInstance = new simpleVideo(simpleVideoContentElements[i]);
        }
        for (i = 0; i < embedVideoContentElements.length; ++i) {
            var embedVideoInstance = new embedVideo(embedVideoContentElements[i]);
        }
    });
})();
